var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"button"},on:{"click":_vm.abrirModal}},[_c('app-svg-symbol',{attrs:{"width":"16","name":"@escavador/refresh"}})],1),_vm._v(" "),(this.showModal)?_c('modal-confirmar-novo-token-callback',{attrs:{"visible":_vm.showModal},on:{"closeModal":_vm.closeModal}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }